module.exports = __webpack_public_path__ + "img/icon-sponsored-star.d3f3957d.svg";